import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/** @jsx jsx */

import { memo, useState } from 'react';
import { jsx } from '@emotion/core';
import { Manager, Reference } from '@atlaskit/popper';
import Portal from '@atlaskit/portal';
import { layers } from '@atlaskit/theme/constants';
import PopperWrapper from './PopperWrapper';
var defaultLayer = layers.layer();
export var Popup =
/*#__PURE__*/
memo(function (_ref) {
  var isOpen = _ref.isOpen,
      id = _ref.id,
      offset = _ref.offset,
      testId = _ref.testId,
      trigger = _ref.trigger,
      content = _ref.content,
      onClose = _ref.onClose,
      boundary = _ref.boundary,
      _ref$rootBoundary = _ref.rootBoundary,
      rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary,
      _ref$shouldFlip = _ref.shouldFlip,
      shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'auto' : _ref$placement,
      PopupContainer = _ref.popupComponent,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? defaultLayer : _ref$zIndex;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      triggerRef = _useState2[0],
      setTriggerRef = _useState2[1];

  return jsx(Manager, null, jsx(Reference, null, function (_ref2) {
    var _ref3 = _ref2.ref;
    return trigger({
      ref: function ref(node) {
        if (node && isOpen) {
          if (typeof _ref3 === 'function') {
            _ref3(node);
          } else {
            _ref3.current = node;
          }

          setTriggerRef(node);
        }
      },
      'aria-controls': id,
      'aria-expanded': isOpen,
      'aria-haspopup': true
    });
  }), isOpen && jsx(Portal, {
    zIndex: zIndex
  }, jsx(PopperWrapper, {
    content: content,
    isOpen: isOpen,
    placement: placement,
    boundary: boundary,
    rootBoundary: rootBoundary,
    shouldFlip: shouldFlip,
    offset: offset,
    popupComponent: PopupContainer,
    id: id,
    testId: testId,
    onClose: onClose,
    autoFocus: autoFocus,
    triggerRef: triggerRef
  })));
});
export default Popup;